import { IClientProfile } from "../../types/profile/IClientProfile";
import { ClientProfileResponse } from "../controllers/settings/clientProfileResponse";

export const convertClientProfileResponse = (
    res: ClientProfileResponse
): IClientProfile => {
    if (!res) return null;

    const client: IClientProfile = {
        clientUserId: res.clientId,
        firstName: res.firstName,
        lastName: res.lastName,
        email: res.email,
        phoneNumber: res.phoneNumber,
        isAgentActive: res.isAgentActive,
    };
    return client;
};
